/* Tastatur-Loop ans Seitenende (Kundenwunsch 18.08.): steht der Fokus auf dem letzten
   fokussierbaren Element des Dokuments und wird Tab (ohne Shift) gedrückt, springt der
   Fokus zurück auf das erste fokussierbare Element der Seite — Tastatur-Nutzer landen
   so nicht im Browser-Chrome, sondern wieder am Seitenanfang (Skip-Link). */

const FOCUSABLE_SELECTOR =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

/**
 * Sichtbar + bedienbar: keine disabled-Controls, keine tabindex="-1"-Elemente (z. B. das
 * Honeypot-Feld der Formulare — der Browser tabbt sie nie an, sie dürfen deshalb nie
 * "letztes Element" der Liste werden) und nichts Unsichtbares. checkVisibility mit
 * checkOpacity deckt auch opacity:0 in der Ahnenkette ab — die geschlossene Cookiebar
 * (.cc-inner, oveleon/contao-cookiebar) versteckt ihre Buttons NUR per opacity und
 * die behalten ClientRects/Tab-Fokus; ohne den Opacity-Check zählte der Loop sie mit
 * und das sichtbare Seitenende wurde nie als "letztes Element" erkannt.
 *
 * @param {Element} el
 * @returns {boolean}
 */
function isFocusable(el) {
    if (el.tabIndex < 0 || el.matches(':disabled')) return false;

    if (typeof el.checkVisibility === 'function') {
        return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    }

    // Fallback (ältere Browser): getClientRects deckt display:none/detached ab —
    // offsetParent wäre bei position:fixed (z. B. der Cookiebar) fälschlich null
    return el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
}

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || event.shiftKey || event.defaultPrevented) return;

    // Liste bei jedem Tab-Druck frisch ermitteln — Cookiebar, aufklappende Menüs und
    // nachgeladene Inhalte verändern die fokussierbaren Elemente zur Laufzeit.
    const focusable = [...document.querySelectorAll(FOCUSABLE_SELECTOR)].filter(isFocusable);
    if (!focusable.length) return;

    if (document.activeElement === focusable[focusable.length - 1]) {
        event.preventDefault();
        focusable[0].focus();
    }
});

/* Fokus-Modalität für die Formularfelder (Kundenwunsch 18.08., _form_solid.scss):
   Chrome wertet Textfelder bei JEDER Fokusart als :focus-visible — auch beim Mausklick.
   Der Kundenwunsch "Outline + Hervorhebung nur bei Tastatur-Fokus" braucht deshalb eine
   JS-Unterscheidung: Tab setzt .kbd-focus auf <html>, ein Pointer-Druck entfernt sie.
   Capture-Phase, damit die Klasse VOR dem Fokuswechsel des Browsers stimmt. */
document.addEventListener(
    'keydown',
    (event) => {
        if (event.key === 'Tab') document.documentElement.classList.add('kbd-focus');
    },
    true
);

document.addEventListener(
    'pointerdown',
    () => {
        document.documentElement.classList.remove('kbd-focus');
    },
    true
);
